function precisionRound(number, precision, forcePrecision = false) {
	if (typeof precision === "undefined" || typeof number === "undefined") {
		console.warn(`Precision round error: Please provide both a number and precision value`);
	}

	const factor = 10 ** precision;
	const preciseNumber = ((Math.round(number * factor)) / factor);
	return !forcePrecision ? preciseNumber : preciseNumber.toFixed(precision);
}

export { precisionRound };
export default precisionRound;



// WEBPACK FOOTER //
// ./src/mixins/precision-round.js